/** Take in an incoming StateChange from firebase and make it safe. */
//EX: converting `false` back to an empty array.
export function decodeSafeFirebaseRolloutStateChange(stateChangeInput) {

    let safeStateChange = {...stateChangeInput};

    //Convert back to empty array from false. Firebase won't save empty arrays, so we must save a `false` Boolean instead
    if (safeStateChange.items === false) {
        safeStateChange.items = [];
    }

    return safeStateChange

}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase-safe.js